<template>
  <vue-editor class="html-editor" v-model="content" @text-change="$emit('text-change', content)"
    :editorToolbar="customToolbar" :editorOptions="editorOptions" />
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor-table'

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    editorOptions: {
      type: Object,
      default() {
        return {
          spellCheck: false
        }
      }
    }
  },
  components: {
    VueEditor
  },
  watch: {
    value(val) {
      this.content = val
    }
  },
  data() {
    return {
      content: this.value,
      customToolbar: null,
    }
  },
  methods: {
    init() {
      const fontList = ['Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Lucida Sans Unicode',  'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana']
      const fontNames = fontList.map(font => this.getFontName(font))
      const fonts = Quill.import('attributors/style/font')
      fonts.whitelist = fontNames
      Quill.register(fonts, true)

      const fontSizeArr = ['8px','9px','10px','11px','12px','14px','16px','18px','20px','22px','24px','26px','28px','36px','48px','72px'];
      const fontSize = Quill.import('attributors/style/size');
      fontSize.whitelist = fontSizeArr;
      Quill.register(fontSize, true);
      
      let fontStyles = ""
      fontList.forEach(font => {
          let fontName = this.getFontName(font)
          fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
              "content: '" + font + "';" +
              "font-family: '" + font + "', sans-serif;" +
              "}"
      })
      //  +
      //         ".ql-font-" + fontName + "{" +
      //         " font-family: '" + font + "', sans-serif;" +
      //         "}"

      fontSizeArr.forEach(font => {
          fontStyles += ".ql-snow .ql-picker.ql-size .ql-picker-label[data-value='" + font + "']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='" + font + "']::before {" +
              "content: '" + font + "' !important;" +
              "}"
      })
      // "font-size: " + font + " !important;" +

      // console.log('Quill', Quill)

      const node = document.createElement('style')
      node.innerHTML = fontStyles
      document.body.appendChild(node)

      this.customToolbar = [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image', 'video'],
        ['clean'],
        [{ 'font': fonts.whitelist }],
        [{ 'size': fontSize.whitelist }]
      ]
    },
    getFontName(font) {
      return font.toLowerCase().replace(/\s/g, "-")
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
</style>
